const e=e=>{if(Number.isInteger(e))return e.toLocaleString("en-US");const t=Number(e).toLocaleString("en-US").split(".");return`${t[0]}.${t[1].padEnd(2,"0")}`};export{e as toFloatString};
//# sourceMappingURL=toFloatString.js.map
